export default __webpack_public_path__ + "src/assets/Pooltogether_Desktop.5d8cd7503687e1f222ec1fe5c7d57af0.svg";